"use strict";

(function ($) {
  $(document).ready(function () {
    // DO the things
    $("#clear").click(function () {
      basket = [];
      location.reload();
      $.cookie("baskets", JSON.stringify(basket), { path: "/" });
    });
  }); // END document ready
})(jQuery);